"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("@creditas-lab/button");

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _core = require("@emotion/core");

var Login = function Login() {
  var _LoginCtaTypes$device, _LoginCtaTypes$device2;

  var _ref = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      device = _ref2$.device,
      isCustomType = _ref2$.isCustomType,
      handleDispatchMenuEvents = _ref2[1].handleDispatchMenuEvents;

  var loginCtaCommonProps = {
    as: 'a',
    href: "https://app.creditas.com/auth/",
    onClick: function onClick() {
      return handleDispatchMenuEvents({
        action: 'inbound links | entrar',
        label: "https://app.creditas.com/auth/"
      });
    }
  };
  var LoginCtaTypes = {
    mobile: {
      component: _UiComponents.Typo.Login,
      props: _objectSpread({
        mobile: '2xl',
        desktop: 'md',
        weight: 'xs'
      }, loginCtaCommonProps)
    },
    desktop: {
      component: _button.Button,
      props: _objectSpread(_objectSpread({}, loginCtaCommonProps), {}, {
        size: isCustomType ? 'small' : 'medium'
      })
    }
  };
  var LoginCta = ((_LoginCtaTypes$device = LoginCtaTypes[device]) == null ? void 0 : _LoginCtaTypes$device.component) || null;
  return (0, _core.jsx)(_UiComponents.Container.Login, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
    alignItems: "center"
  }, LoginCta && (0, _core.jsx)(LoginCta, (_LoginCtaTypes$device2 = LoginCtaTypes[device]) == null ? void 0 : _LoginCtaTypes$device2.props, "Entrar")));
};

exports.Login = Login;
Login.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Login"
};